import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import notification from '@tt/components/Notification';
import Actions, { ActionTypes } from './actions';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* addLineRejection({ lineRejectionData, callback }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    yield call(api.post, {
      route: 'lineRejection/CreateScrapForShiftAndLineJob',
      data: lineRejectionData,
    });
    notification('success', CONSTANT_VARIABLES.LINE_REJECTION_CREATED, '');
    if (callback) callback();
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.error('api call error ', err);
  }
}
function* addAutoReconcile({ autoReconcile, callback }) {
  try {
    yield put(Actions.setAutoReconcileLoader({ showAutoReconcileLoader: true }));
    yield call(api.post, {
      route: 'accumulation/SaveLineJobAutoReconciliation',
      data: autoReconcile,
    });
    notification('success', CONSTANT_VARIABLES.AUTO_RECONCILE_SUCCESSFULLY, '');
    if (callback) callback();
    yield put(Actions.setAutoReconcileLoader({ showAutoReconcileLoader: false }));
  } catch (err) {
    yield put(Actions.setAutoReconcileLoader({ showAutoReconcileLoader: false }));
    notification('error', err.toString(), '');
    console.error('api call error ', err);
  }
}
function* updateLineRejection({ lineRejectionData, callback }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    yield call(api.put, {
      route: 'lineRejection/UpdateLineRejection',
      data: lineRejectionData,
    });
    notification('success', CONSTANT_VARIABLES.LINE_REJECTION_UPDATED, '');
    if (callback) callback();
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.error('api call error ', err);
  }
}
function* deleteLineRejection({ lineRejectionId, callback }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    yield call(api.delete, {
      route: 'lineRejection/DeleteLineRejection/' + lineRejectionId,
    });
    notification('success', CONSTANT_VARIABLES.LINE_REJECTION_UPDATED, '');
    if (callback) callback();
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.error('api call error ', err);
  }
}

function* addRework({ reworkData, callback }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    yield call(api.post, {
      route: 'production/CreateReworkForShiftAndJob',
      data: reworkData,
    });
    notification('success', CONSTANT_VARIABLES.REWORK_CREATED, '');
    if (callback) callback();
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.error('api call error ', err);
  }
}
function* updateRework({ reworkData, callback }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    yield call(api.put, {
      route: 'production/UpdateRework',
      data: reworkData,
    });
    notification('success', CONSTANT_VARIABLES.REWORK_UPDATED, '');
    if (callback) callback();
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.error('api call error ', err);
  }
}
function* deleteRework({ reworkId, callback }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    yield call(api.delete, {
      route: 'production/DeleteRework/' + reworkId,
    });
    notification('success', CONSTANT_VARIABLES.REWORK_DELETED, '');
    if (callback) callback();
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.error('api call error ', err);
  }
}

function* fetchLineJobReconciliation({ jobId }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'accumulation/GetLineJobReconciliationData/' + jobId,
    });
    const reconciliationData = data.toJS();
    yield put(Actions.setLineJobReconciliation({ reconciliationData }));
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.error('api call error ', err);
  }
}

function* fetchAccumulationsForNewJobByLineId({ lineId }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'accumulation/GetAccumulationsForNewJobByLineId/' + lineId,
    });
    const accumulationForNewJob = data ? data.toJS() : [];
    yield put(Actions.setAccumulationsForNewJob({ accumulationForNewJob }));
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (error) {
    notification('error', error.toString(), '');
    console.error('api call error ', error);
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  }
}

function* fetchLineJobShifts({ lineJobId }) {
  try {
    yield put(Actions.setLineJobEquipmentShiftsLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `accumulation/GetAccumulationLineShiftByLineJobId/${lineJobId}`,
    });
    const lineJobShifts = data ? data.toJS() : [];
    yield put(Actions.setLineJobShifts({ lineJobShifts }));
    yield put(Actions.setLineJobEquipmentShiftsLoader({ showLoader: false }));
  } catch (error) {
    notification('error', error.toString(), '');
    console.error('api call error ', error);
    yield put(Actions.setLineJobEquipmentShiftsLoader({ showLoader: false }));
  }
}

function* fetchLineCurrentShiftProductions({ lineJobId }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `production/GetLineJobCurrentShiftProduction/${lineJobId}`,
    });
    yield put(Actions.setLineCurrentShiftProductions({ lineCurrentShiftProductions: data }));
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (error) {
    notification('error', error.toString(), '');
    console.error('api call error ', error);
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  }
}

function* fetchAccumulationByIdAndFilterByCurrentShift({ id, isCurrentShift }) {
  try {
    yield put(Actions.setAccumulationModalLoader({ accumulationModalLoader: true }));
    const { data } = yield call(api.get, {
      route: `accumulation/GetAccumulationById/${id}/${isCurrentShift}`,
    });
    const currentAccumulation = data ? data.toJS() : {};
    yield put(Actions.setCurrentAccumulation({ currentAccumulation }));
    yield put(Actions.setAccumulationModalLoader({ accumulationModalLoader: false }));
  } catch (error) {
    notification('error', error.toString(), '');
    console.error('api call error ', error);
    yield put(Actions.setAccumulationModalLoader({ accumulationModalLoader: false }));
  }
}
function* fetchLineJobTotalAccumulation({ jobId }) {
  try {
    yield put(Actions.setAccumulationModalLoader({ accumulationModalLoader: true }));
    const { data } = yield call(api.get, {
      route: `accumulation/GetLineJobTotalAccumulation/${jobId}`,
    });
    const result = data ? data.toJS() : {};
    yield put(Actions.setLineJobTotalAccumulation({ lineJobTotalAccumulation: result }));
    yield put(Actions.setAccumulationModalLoader({ accumulationModalLoader: false }));
  } catch (error) {
    notification('error', error.toString(), '');
    console.error('api call error ', error);
    yield put(Actions.setAccumulationModalLoader({ accumulationModalLoader: false }));
  }
}
function* fetchFinishGoodRejection({ lineJobId, positionId, isCurrentShift }) {
  try {
    yield put(Actions.setAccumulationModalLoader({ accumulationModalLoader: true }));
    const { data } = yield call(api.get, {
      route: `accumulation/GetFinishGoodRejection/${lineJobId}/${positionId}/${isCurrentShift}`,
    });
    const result = data ? data.toJS() : {};
    yield put(Actions.setFinishGoodRejection({ finishGoodRejection: result }));
    yield put(Actions.setAccumulationModalLoader({ accumulationModalLoader: false }));
  } catch (error) {
    notification('error', error.toString(), '');
    console.error('api call error ', error);
    yield put(Actions.setFinishGoodRejection({ accumulationModalLoader: false }));
  }
}
function* addGoodCount({ goodCountData, callback }) {
  try {
    yield put(Actions.setAccumulationLoader({ showLoader: true }));
    yield call(api.post, {
      route: 'production/CreateGoodUnits',
      data: goodCountData,
    });
    notification('success', CONSTANT_VARIABLES.LINE_GOOD_COUNT_CREATED, '');
    if (callback) callback();
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setAccumulationLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.error('api call error ', err);
  }
}
export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.ADD_LINE_REJECTION, addLineRejection),
    takeLatest(ActionTypes.AUTO_RECONCILE, addAutoReconcile),
    takeLatest(ActionTypes.ADD_REWORK, addRework),
    takeLatest(ActionTypes.UPDATE_LINE_REJECTION, updateLineRejection),
    takeLatest(ActionTypes.UPDATE_REWORK, updateRework),
    takeLatest(ActionTypes.DELETE_LINE_REJECTION, deleteLineRejection),
    takeLatest(ActionTypes.DELETE_REWORK, deleteRework),
    takeLatest(ActionTypes.FETCH_LINE_JOB_RECONCILIATION, fetchLineJobReconciliation),
    takeLatest(ActionTypes.FETCH_NEW_LINE_JOB_ACCUMULATION, fetchAccumulationsForNewJobByLineId),
    takeLatest(ActionTypes.FETCH_LINE_JOB_SHIFTS, fetchLineJobShifts),
    takeLatest(
      ActionTypes.FETCH_ACCUMULATION_BY_ID_FILTER_BY_CURRENT_SHIFT,
      fetchAccumulationByIdAndFilterByCurrentShift
    ),
    takeLatest(ActionTypes.FETCH_LINE_JOB_TOTAL_ACCUMULATION, fetchLineJobTotalAccumulation),
    takeLatest(ActionTypes.FETCH_LINE_CURRENT_SHIFT_PRODUCTIONS, fetchLineCurrentShiftProductions),
    takeLatest(ActionTypes.ADD_GOOD_COUNT, addGoodCount),
    takeLatest(ActionTypes.FETCH_FINISH_GOOD_REJECTION, fetchFinishGoodRejection),
  ]);
}
